import { Wrap, Title, Content } from './styles';

import Icon from '@map/components/Icons';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';

/**
 * Painel inferior deslizante, usado apenas no Mobile
 */
const MobileSwipeableDialog = ({
  opnedHeight,
  startHeight,
  title,
  onClose,
  children,
  ...props
}) => {
  return (
    <Wrap>
      <Title>
        <button onClick={onClose}>
          <svg
            width="9"
            height="17"
            viewBox="0 0 9 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.04087 0.484473C7.96238 0.414474 7.87084 0.360655 7.7715 0.326103C7.67217 0.29155 7.56699 0.276942 7.462 0.283117C7.35701 0.289292 7.25427 0.316129 7.15967 0.362088C7.06507 0.408047 6.98047 0.472225 6.91072 0.550943L0.503977 7.75853C0.37364 7.90503 0.301636 8.09429 0.301636 8.29037C0.301636 8.48646 0.37364 8.67571 0.503977 8.82221L6.91072 16.0298C7.05359 16.1816 7.25001 16.2717 7.45824 16.2809C7.66648 16.2902 7.87013 16.2179 8.02592 16.0794C8.18171 15.941 8.27737 15.7472 8.29257 15.5393C8.30778 15.3314 8.24133 15.1258 8.10734 14.9661L2.17374 8.29037L8.10734 1.61462C8.17725 1.53608 8.23099 1.44454 8.26549 1.34521C8.29999 1.24588 8.31457 1.14073 8.3084 1.03577C8.30223 0.930803 8.27542 0.828085 8.22951 0.733489C8.18361 0.638893 8.11951 0.554274 8.04087 0.484473Z"
              fill="white"
            />
          </svg>
        </button>
        <h1>{title}</h1>
      </Title>
      <Content>
        <SwipeableBottomSheet overflowHeight={startHeight ? startHeight : 60}>
          <div style={{ height: opnedHeight ? opnedHeight : '50vh' }}>
            <div className="top-icon">
              <Icon i="map-swipeable" />
            </div>
            {children}
          </div>
        </SwipeableBottomSheet>
      </Content>
    </Wrap>
  );
};

MobileSwipeableDialog.propTypes = {
  /** Altura total do painel quando aberto. Ex: `50vh` */
  opnedHeight: PropTypes.string,
  /** Altura (em px) do painel quando fechado. Ex: 60 */
  startHeight: PropTypes.number,
  /** Titulo exibido na parte superior da tela */
  title: PropTypes.string,
  /** Função que deve ser executada ao fechar o painel  */
  onClose: PropTypes.func,
  /** Conteúdo que será exibido no painel */
  children: PropTypes.any,
};

export default MobileSwipeableDialog;
